<template>
    <div class="green-box" v-if="giveaway">
        <div class="giveaway-box-title-container">
            FREE <span class="giveaway-box-title">{{giveaway.Title}}</span> GIVEAWAY. SIGNUP AND WIN.
        </div>
        <div class="countdown">
            <div class="text-title text-pink">
                <span class="text-black text-bold">{{countdown.days}}</span> days 
                <span class="text-black text-bold">{{countdown.hours}}</span> hours 
                <br class="line-break">&nbsp;
                <span class="text-black text-bold">{{countdown.minutes}}</span> minutes 
                <span class="text-black text-bold">{{countdown.seconds}}</span> seconds
            </div>
        </div>
        <div class="moreinfo">
            <a href="/giveaway">
                <button class="button button-small button-green">MORE INFO</button>
            </a>
        </div>
    </div>
</template>

<script>

import api from '@/api'



export default {
    data() {
        return {
            countdown: {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            },
            giveaway: null
        }
    },
    created() {
        this.init();
    },
    methods: {
        init() 
        {

            //GET GIVEAWAY INFO
            api.getGiveawayInfo().then(response => {
                
                var giveaway = response.data
                if(giveaway && giveaway.IsStillOn) {
                    this.giveaway = giveaway;
                    this.startCountdown();
                }
                

            });
            
        },
        startCountdown() {
            if(this.giveaway.MillisecondsLeft && this.giveaway.MillisecondsLeft > 0) {
                this.countdown.days = Math.floor(this.giveaway.MillisecondsLeft / (1000 * 60 * 60 * 24));
                this.countdown.hours = Math.floor((this.giveaway.MillisecondsLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                this.countdown.minutes = Math.floor((this.giveaway.MillisecondsLeft % (1000 * 60 * 60)) / (1000 * 60));
                this.countdown.seconds = Math.floor((this.giveaway.MillisecondsLeft % (1000 * 60)) / 1000);
                this.giveaway.MillisecondsLeft = this.giveaway.MillisecondsLeft - 1000;
            }

            setInterval(() => {
                if(this.giveaway.MillisecondsLeft && this.giveaway.MillisecondsLeft > 0) {
                    this.countdown.days = Math.floor(this.giveaway.MillisecondsLeft / (1000 * 60 * 60 * 24));
                    this.countdown.hours = Math.floor((this.giveaway.MillisecondsLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    this.countdown.minutes = Math.floor((this.giveaway.MillisecondsLeft % (1000 * 60 * 60)) / (1000 * 60));
                    this.countdown.seconds = Math.floor((this.giveaway.MillisecondsLeft % (1000 * 60)) / 1000);
                    this.giveaway.MillisecondsLeft = this.giveaway.MillisecondsLeft - 1000;
                }
                else
                {
                    this.countdown.days = 0;
                    this.countdown.hours =  0;
                    this.countdown.minutes = 0;
                    this.countdown.seconds = 0;
                }
            }, 1000);
            
        }
   }
}
</script>
